// src/pages/SubscriptionManagement.js
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useState } from 'react';

function SubscriptionManagement() {
  const { subscription } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [cancelled, setCancelled] = useState(false);

  const handleCancelSubscription = async () => {
    if (!window.confirm('Er du sikker på at du vil opsige? Du beholder adgang til udløbet af din nuværende betalingsperiode.')) {
      return;
    }
    setLoading(true);
    setError('');
    try {
      // TODO: call backend to cancel Stripe subscription
      await new Promise(resolve => setTimeout(resolve, 800));
      setCancelled(true);
    } catch (err) {
      setError('Opsigelse mislykkedes: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!subscription) {
    return (
      <div style={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <div style={{ width: '100%', maxWidth: 440, textAlign: 'center' }}>
          <div style={{
            width: 64,
            height: 64,
            background: 'var(--bg-elevated)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: 24,
          }}>🎧</div>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 12 }}>
            Intet aktivt abonnement
          </h1>
          <p style={{ fontSize: 16, color: 'var(--text-secondary)', marginBottom: 32, lineHeight: 1.6 }}>
            Du har ikke et aktivt Faircast-abonnement endnu.
          </p>
          <Link to="/subscribe" className="fc-cta-primary" style={{ display: 'inline-flex' }}>
            Se abonnementsplaner
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '64px 20px', maxWidth: 560, margin: '0 auto' }}>
      <span className="fc-eyebrow">Abonnement</span>
      <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--text-primary)', marginBottom: 32 }}>
        Dit abonnement
      </h1>

      {error && (
        <div style={{
          background: 'rgba(220,38,38,0.1)',
          border: '1px solid rgba(220,38,38,0.3)',
          borderRadius: 10,
          padding: '10px 14px',
          fontSize: 14,
          color: '#f87171',
          marginBottom: 20,
        }}>{error}</div>
      )}

      {cancelled && (
        <div style={{
          background: 'rgba(34,197,94,0.1)',
          border: '1px solid rgba(34,197,94,0.3)',
          borderRadius: 10,
          padding: '10px 14px',
          fontSize: 14,
          color: '#4ade80',
          marginBottom: 20,
        }}>Abonnement opsagt. Du beholder adgang til periodens udløb.</div>
      )}

      {/* Current plan */}
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: 16,
        padding: '24px',
        marginBottom: 24,
      }}>
        <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 16 }}>
          Nuværende plan
        </div>
        {[
          { label: 'Plan', value: subscription.planId === 'monthly' ? 'Månedlig — 30 kr/md.' : 'Årlig' },
          { label: 'Status', value: cancelled ? 'Opsagt' : 'Aktiv', highlight: !cancelled },
          { label: 'Næste betaling', value: subscription.currentPeriodEnd
              ? new Date(subscription.currentPeriodEnd).toLocaleDateString('da-DK')
              : '—' },
        ].map(row => (
          <div key={row.label} style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            fontSize: 14,
            borderBottom: '1px solid var(--border-color)',
          }}>
            <span style={{ color: 'var(--text-secondary)' }}>{row.label}</span>
            <span style={{
              fontWeight: 700,
              color: row.highlight ? 'var(--primary-color)' : 'var(--text-primary)',
            }}>{row.value}</span>
          </div>
        ))}

        {!cancelled && (
          <button
            onClick={handleCancelSubscription}
            disabled={loading}
            style={{
              marginTop: 20,
              padding: '10px 18px',
              background: 'transparent',
              border: '1px solid rgba(220,38,38,0.4)',
              borderRadius: 10,
              color: '#f87171',
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Behandler…' : 'Opsig abonnement'}
          </button>
        )}
      </div>

      {/* Payment history placeholder */}
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: 16,
        padding: '24px',
      }}>
        <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 16 }}>
          Betalingshistorik
        </div>
        <p style={{ fontSize: 14, color: 'var(--text-mute)', lineHeight: 1.6 }}>
          Din betalingshistorik vises her når Stripe-integrationen er aktiv.
        </p>
      </div>
    </div>
  );
}

export default SubscriptionManagement;
